import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';

// Import dashboard translation files
import dashboardEN from './locales/en/dashboard.json';
import dashboardFR from './locales/fr/dashboard.json';

// Import divorce guide translations
import divorceEN from './locales/en/divorce.json';
import divorceFR from './locales/fr/divorce.json';

// Import common translations
import commonEN from './locales/en/common.json';
import commonFR from './locales/fr/common.json';

// Import garde guide translations
import gardeEN from './locales/en/garde.json';
import gardeFR from './locales/fr/garde.json';

// Import pension guide translations
import pensionEN from './locales/en/pension.json';
import pensionFR from './locales/fr/pension.json';

// Import separation guide translations
import separationEN from './locales/en/separation.json';
import separationFR from './locales/fr/separation.json';

// Import timeline translations
import timelineEN from './locales/en/timeline.json';
import timelineFR from './locales/fr/timeline.json';

// Import sepleg translations
import seplegEN from './locales/en/sepleg.json';
import seplegFR from './locales/fr/sepleg.json';

// Import Clico Search translations
import clicoSearchEN from './locales/en/clicoSearch.json';
import clicoSearchFR from './locales/fr/clicoSearch.json';

// the translations
const resources = {
  en: {
    translation: translationEN,
    dashboard: dashboardEN,
    divorce: divorceEN,
    common: commonEN,
    garde: gardeEN,
    pension: pensionEN,
    separation: separationEN,
    timeline: timelineEN,
    sepleg: seplegEN,
    clicoSearch: clicoSearchEN
  },
  fr: {
    translation: translationFR,
    dashboard: dashboardFR,
    divorce: divorceFR,
    common: commonFR,
    garde: gardeFR,
    pension: pensionFR,
    separation: separationFR,
    timeline: timelineFR,
    sepleg: seplegFR,
    clicoSearch: clicoSearchFR
  }
};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    lng: 'fr', // Force French as the default language
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    // language detection options
    detection: {
      order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag'], // Changed order to prioritize stored preferences
      lookupQuerystring: 'lang',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    }
  });

export default i18n; 